import React from 'react';
import BasketballStat from '../../basketball/Stat';
import SoccerStat from '../../soccer/Stat';
import VolleyBallStat from '../../volleyball/Stat';
import HockeyStat from '../../hockey/Stat';
import FootballStat from '../../hockey/Stat';
import BaseballStat from '../../baseball/Stat';
import { toJS } from 'mobx';
import LolStat from 'components/match/lol/Stat';

const StatWrapper = ({ sportsType, gameData }) => {
  let renderComponent = null;
  switch (sportsType) {
    case 'baseball':
      renderComponent = <BaseballStat gameData={gameData} />;
      break;
    case 'basketball':
      renderComponent = <BasketballStat gameData={gameData} />;
      break;
    case 'soccer':
      renderComponent = <SoccerStat gameData={gameData} />;
      break;
    case 'volleyball':
      renderComponent = <VolleyBallStat />;
      break;
    case 'hockey':
      renderComponent = <HockeyStat />;
      break;
    case 'football':
      renderComponent = <FootballStat />;
      break;
    case 'lol':
      renderComponent = <LolStat />;
      break;
  }
  return <div>{renderComponent}</div>;
};

export default StatWrapper;
